
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Group,
XInput,
XButton,
Icon,
Cell,
LoadMore
},
data() {
return {
pageIndex: 1,
chapterId: this.$route.query.chapterid, //章节编号
findchar: "",
subjectList: [],
isSubjectLoadMore: false,
isShowSubjectLoadMore: false
};
},
created() {
this.initData();
},
methods: {
initData() {
this.pageIndex = 1;
this.findchar = "";
this.subjectList = [];
this.isShowSubjectLoadMore = false;
this.searchSubjectList(false);
},
onSearchClick() {
this.searchSubjectList(false);
},
searchSubjectList(isMore) {
if (!isMore) {
this.$vux.loading.show({
text: "请稍候..."
});

this.isShowSubjectLoadMore = true;
}



this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjectListForQuickRead",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
chapterId:this.chapterId,
pagesize: 20,
pageindex:this.pageIndex,
findchar: this.findchar
}
})
.then(response => {

if (response.status == 200 && response.data.errcode == 0) {


if (this.subjectList != undefined && isMore) {
this.isSubjectLoadMore = false;
} else {
this.subjectList = [];
this.$vux.loading.hide();
}

this.pageIndex++;
response.data.data.forEach(subject => {


subject.ctitle = subject.ctitle.replace(/<img /ig,'<img style="max-width:100%;overflow:hidden;" ');
subject.ctitle = subject.ctitle.replace(/\n/ig,'<br />');
this.subjectList.push(subject);
});

if (
response.data.data != undefined &&
response.data.data.length < 20
) {
this.isShowSubjectLoadMore = false;
}
} else {
this.isSubjectLoadMore = false;
this.$vux.loading.hide();
}
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
this.isSubjectLoadMore = false;
});
},
onSubjectClick(subjectItem) {
var listId = Date.parse(new Date());
var stroageSubjectList = {
id: listId,
list: this.subjectList
};
sessionStorage.setItem("subjectList", JSON.stringify(stroageSubjectList));

this.$router.push({
path: "/SubjuectData",
query: {
subjectid: subjectItem.isubjectid,
showtime: this.GLOBAL.SubjectShowTime.Test,
listid: listId
}
});
},
onSubjectMore() {
this.isSubjectLoadMore = true;
this.searchSubjectList(true);
},
},
computed: {
swiperHeight: function() {
return document.documentElement.clientHeight - 115 + "px";
}
},
watch: {
$route(to, from) {
if (from.path == "/") {
this.initData();
}
}
}
};




// WEBPACK FOOTER //
// ./src/components/QuickReadSubject.vue